module.exports = __webpack_public_path__ + "img/heptagon-half.c179ec88.svg";